import React, {useEffect, useState} from 'react';
import './App.css';
import {basePath} from './options';
import Clock from "./Clock";

function School(props){

    let [html, setHtml] = useState("");
    let [flag, setFlag] = useState(false);
    let [clocks, setClocks] = useState([]);
    let [done, setDone] = useState(false);

    useEffect(()=>{
    fetch(props.link)
        .then(response => response.text())
        .then(html => {setHtml(html); setFlag(true);});
    }, [props.link]);

    useEffect(()=>{
    if(html !== "" ){
        let table = html.split("table")[1];
        let rows = table.split("tr>");
        let arr = [];
        for(let i = 3; i<rows.length; i++){
        /*let link = rows[i].split("href=")[1];
        link = link.split('"')[1];
        link = basePath+link;
        link = link.replaceAll("&amp;", "&");*/
        
        let name = rows[i].split('>')[2];
        name = name.replaceAll("</a", "");

        let link = basePath+"/Device/history/"+name+"?days=3000";

        let room = rows[i].split("td>")[9];
        room = room.replaceAll("</", "");
        
        let date = rows[i].split("td>")[3];
        if(date.includes("span")){
            date = date.split(">")[1];
            date = date.split("<")[0];
        }else{
            date = date.replace("</", "");
        }
        date = date.replaceAll(" ", ".");
        date = date.replaceAll("..", "");
        date = date.replaceAll(".", " ");
        date = date.split("&")[0];
        
        arr.push({link:link, name:name, date:date, room:room});
        i++;
        }
        setClocks(arr);
    }
    }, [flag]);

    let header;
    if(props.moreInfo){
        header = <tr>
            <th>SN</th>
            <th>Last Check In</th>
            <th>Current Voltage</th>
            <th>Lowest Voltage</th>
            <th>Location</th>
        </tr>;
    }else{
        header = <tr>
            <th>SN</th>
            <th>Location</th>
        </tr>;
    }

    let display;
    if(!flag){
        display=<div><h4>Loading....</h4></div>;
    }else{
        display =<div>
            <a href={props.link} target="_blank"><h4>{props.name}</h4></a>
            <p>{(done)? "Complete": "Processing..."}</p>
            <table style={{display:"inline-block"}}>
                <thead>
                    {header}
                </thead>
                <tbody>
                    {clocks.map((element, i)=>{
                        if(clocks.length === i+1){
                            return (
                                
                                    <Clock
                                        key={element.name}
                                        name={element.name}
                                        link={element.link}
                                        date={element.date}
                                        last={true}
                                        setDone={(bool)=>{setDone(bool);props.setDone([...props.doneList, bool]);}}
                                        useMin={props.useMin}
                                        min={props.min}
                                        room={element.room}
                                        moreInfo={props.moreInfo}
                                    />
                                );
                        }else{
                            return (
                                
                                    <Clock
                                        key={element.name}
                                        name={element.name}
                                        link={element.link}
                                        date={element.date}
                                        last={false}
                                        useMin={props.useMin}
                                        min={props.min}
                                        room={element.room}
                                        moreInfo={props.moreInfo}
                                    />
                                );
                        }
                        
                    })}
                </tbody>
            </table>
        </div>;
    }
      
    return (
        <div>{display}</div>
    );
}
export default School;